import React from "react";
import { PasswordResetConfirmBody } from "tsi-common-react/src/apps/customer-account/PasswordResetConfirmBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.PasswordResetConfirmDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <PasswordResetConfirmBody {...props} />
    </PageSkeleton>
);
